import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const SkeletonIconLink: React.FC = () => (
  <div className={styles.iconLink}>
    <Skeleton variant="rectangular" height="21px" width="21px" animation="pulse" />
    <Skeleton variant="rectangular" height="21px" width="200px" animation="pulse" />
  </div>
);

const LoadingState: React.FC = () => (
  <LoadingStateWrapper>
    <Skeleton variant="rectangular" height="48px" width="100%" animation={false} />
    <SkeletonIconLink />
    <SkeletonIconLink />
    <SkeletonIconLink />
    <SkeletonIconLink />
    <SkeletonIconLink />
  </LoadingStateWrapper>
);

export default LoadingState;
